import { breakpoints } from '@notino/react-styleguide';

import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const newDiscoveryCardClass = css`
  padding: 0 1rem;
`;

export const legacyDiscoveryCardClass = css`
  padding: 0;
  @media (min-width: ${breakpoints.lg}) {
    padding: 0 0.9375rem;
  }
`;

export const SliderWrapper = styled.div``;
